// extracted by mini-css-extract-plugin
export default {"shell":"MarketingLayout_shell__2eqPc","main":"MarketingLayout_main__zq6ew"};